import { RequestSender } from "./helpers";

async function setGoogleCourseEnabled(
  request: RequestSender,
  id: string,
  enabled: boolean,
): Promise<void> {
  const response = await request(
    "post",
    `/google-courses/${id}/enabled`,
    enabled,
  );
  if (response.data.message !== "success") {
    throw new Error(response.data.message);
  }
}

export default setGoogleCourseEnabled;
